module.exports = __webpack_public_path__ + "img/f076400.jpg";